
        import { Component, Inject} from 'ng-metadata/core';
        import {getLibraryLogo} from '../../../appConfig/customizationConfig';
        import {getLibraryLogoClickableURL} from '../../../appConfig/customizationConfig';
        import {STATE_NAMES} from '../../../primoExplore/primoExploreStates.module';
        import {getVid, getAttributesMap} from '../../../appConfig/appConfigForward';
		import {ConfigurationUtil} from '../../../nddUtils/configurationUtil.service';

        @Component({
            "selector": "prm-logo",
            templateUrl: 'components/search/topbar/logo/logo.html',
        })
        export class PrmLogo {

            private iconLink:Object;
            private logoURL:Object;
            private vid:string= getVid();
        private  disableLogo:boolean=false;
            private needSref:boolean = false;

            constructor(@Inject('$state') private $state: angular.ui.IStateService, private configurationUtil: ConfigurationUtil) {
                this.getLogoIcon();
                this.setLogoURL();
                if(this.$state.current.name === 'deposit'||this.$state.current.name === 'delivery' || this.$state.current.name === 'canonDelivery' || this.$state.current.name === 'cnameDelivery'){ 
                    this.disableLogo = true; 
                }
            }

            getLogoIcon() {
                    this.iconLink = getLibraryLogo() || 'img/library-logo.png';
            }
            
            public setLogoURL(){
                let libraryLogoClickableURL = getLibraryLogoClickableURL();
                if (libraryLogoClickableURL){
                    this.logoURL = libraryLogoClickableURL;
                }
                else{//if there is no LogoClickableURL...
                    if(this.configurationUtil.getSummonOverAlma() === true){
                    	this.logoURL = getAttributesMap().sessionTimeoutURL;
                    } else {
                        this.needSref = true;
                    }
                }

            }


        }





// WEBPACK FOOTER //
// ./src/main/webapp/components/search/topbar/logo/logo.directive.ts